(function () {
    'use strict';

    angular
        .module('directives.sidebarHelper', [])
        .directive('sidebarHelper', directive);

    directive.$inject = [];

    function directive() {
        return {
            scope: {
                title: '@',
                content: '=',
                moreInfoLink: '@?'
            },
            restrict: 'AE',
            templateUrl: require('./sidebarHelper.tpl.html'),
            controller: ['$scope', '$sce',
                function ($scope, $sce) {
                    $scope.htmlContent = $sce.trustAsHtml($scope.content);
                }]
        }
    }
})();
